import axios from "axios";

export const loginWithCoupon = async (data) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_BASEURL}/api/user/loginwithcoupon`, { ...data, type: "TESTALMONDS" });
        return response;
    } catch (err) {
        return err?.response?.data?.message || err.message;
    }
}